export default __webpack_public_path__ + "static/media/twinstarProtectComplete.ab183d39.jpg";